export function getUrlWithHttps(url: string): string {
  const regEx = /^https?:\/\//i;
  return !regEx.test(url) ? `https://${url}` : url.replace(regEx, 'https://');
}
